import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import {i18n} from './i18n/index.js'
import router from './router.js'
import App from './App.vue'
import VueHead from 'vue-head'

Vue.use(VueObserveVisibility)
Vue.use(VueHead);

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js